export default __webpack_public_path__ + "static/media/03.84c7e548.jpg";